import type { Announcement } from '@/api/announcements'

/** 저장 상태와 별도로, 현재 게시 기간을 표시한다. */
export function getPublicationLabel(
  announcement: Pick<Announcement, 'status' | 'publishStartAt' | 'publishEndAt'>,
  now = Date.now(),
): string {
  if (announcement.status === 'draft') return '초안'
  if (announcement.status === 'archived') return '보관'
  if (announcement.publishEndAt && now > Date.parse(announcement.publishEndAt)) return '게시 종료'
  if (
    (announcement.status === 'scheduled' && !announcement.publishStartAt) ||
    (announcement.publishStartAt && now < Date.parse(announcement.publishStartAt))
  ) return '예약 대기'
  return '게시 중'
}
